import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Traductor } from "../Componentes/Traductor";
import { Formatofecha } from "../Componentes/Formatofecha";
import EditarContenedorModal from "./EditarContenedorModal";
import AsociarPedContenedorModal from "./AsociarPedContenedorModal";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

import "../styles/ListaContenedores.css";

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const ListaContenedores = ({ language }) => {
  const [ListaContenedores, setListaContenedores] = useState([]);
  const [filteredListaContenedores, setFilteredListaContenedores] = useState(
    [],
  );

  //  const [isCreateContenedorModal, setCreateContenedorModal] = useState(false);
  const [isEditModalContenedoresOpen, setEditModalContenedoresOpen] =
    useState(false);
  const [selectedContenedor, setSelectedContenedor] = useState(null);
  const [searchText, setSearchText] = useState("");
  const toastCenter = useRef(null);
  const translations = Traductor(language);

  const { columnsContenedores } = Traductor(language);

  useEffect(() => {
    fetchWithAuth(`${API_URL}/api/listacontenedores`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }
        return response.json();
      })
      .then((data) => {
        // Asegurarse de que 'data' sea un array antes de intentar filtrarlo
        const safeData = Array.isArray(data) ? data : [];
        const filteredData = safeData.filter(
          (contenedor) => contenedor.sNombreEstadoContenedor !== "FINALIZADO",
        );
        setListaContenedores(filteredData);
        setFilteredListaContenedores(filteredData); // Carga todos los contenedores por defecto
      })
      .catch((err) => {
        console.error("Error al cargar los contenedores:", err);
      });
  }, []);

  const showMessage = (severity, summary, detail) => {
    if (toastCenter.current) {
      toastCenter.current.show({ severity, summary, detail, life: 3000 });
    }
  };

  const handleEditContenedor = () => {
    // Validar si el estado del pedido permite editar
    if (
      selectedContenedor &&
      ["CREADO", "ASIGNADO", "DESPACHADO"].includes(
        selectedContenedor.sNombreEstadoContenedor,
      )
    ) {
      setEditModalContenedoresOpen(true); // Abre el modal si el estado lo permite
      //console.log('Modal de edición abierto');
    } else {
      showMessage(
        "error",
        translations.title_error,
        translations.errorEditPedido,
      );
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = ListaContenedores.filter((listacontenedores) => {
      return (
        (listacontenedores.sNroContenedor &&
          listacontenedores.sNroContenedor.toLowerCase().includes(value)) ||
        (listacontenedores.mDescripcion &&
          listacontenedores.mDescripcion.toLowerCase().includes(value)) ||
        (listacontenedores.sSerial &&
          listacontenedores.sSerial.toLowerCase().includes(value))
      );
    });

    setFilteredListaContenedores(filtered);
  };

  const handleCallDespachar = async () => {
    if (!selectedContenedor) {
      showMessage(
        "error",
        translations.title_error,
        translations.errorNoContenedorSeleccionado ||
          "Por favor, selecciona un contenedor.",
      );
      return;
    }

    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/contenedores/despachar`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            IdContenedor: selectedContenedor.IdContenedor,
          }),
        },
      );
      console.log(
        "Response from stored procedure call:",
        response,
        "Id Contenedor",
        selectedContenedor.IdContenedor,
      );

      const data = await response.json();

      if (response.ok) {
        showMessage(
          "success",
          translations.text_Confirmacion,
          data.message ||
            translations.spLlamadoExitoso ||
            "Procedimiento almacenado llamado con éxito.",
        );
        cargarContenedores(); // Recarga la lista de contenedores después de un despacho exitoso
      } else {
        showMessage(
          "error",
          translations.title_error,
          data.message ||
            translations.errorLlamarSp ||
            "Error al llamar al procedimiento almacenado.",
        );
      }
    } catch (error) {
      console.error("Error al llamar al procedimiento almacenado:", error);
      showMessage(
        "error",
        translations.title_error,
        translations.errorLlamarSpGenerico ||
          "Error genérico al llamar al procedimiento almacenado.",
      );
    }
  };

  const handleCallFinalizar = async () => {
    if (!selectedContenedor) {
      showMessage(
        "error",
        translations.title_error,
        translations.errorNoContenedorSeleccionado ||
          "Por favor, selecciona un contenedor.",
      );
      return;
    }

    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/contenedores/finalizar`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            IdContenedor: selectedContenedor.IdContenedor,
          }),
        },
      );
      console.log(
        "Response from stored procedure call:",
        response,
        "Id Contenedor",
        selectedContenedor.IdContenedor,
      );

      const data = await response.json();

      if (response.ok) {
        showMessage(
          "success",
          translations.text_Confirmacion,
          data.message ||
            translations.spLlamadoExitoso ||
            "Procedimiento almacenado llamado con éxito.",
        );
        cargarContenedores(); // Recarga la lista de contenedores después de un despacho exitoso
      } else {
        showMessage(
          "error",
          translations.title_error,
          data.message ||
            translations.errorLlamarSp ||
            "Error al llamar al procedimiento almacenado.",
        );
      }
    } catch (error) {
      console.error("Error al llamar al procedimiento almacenado:", error);
      showMessage(
        "error",
        translations.title_error,
        translations.errorLlamarSpGenerico ||
          "Error genérico al llamar al procedimiento almacenado.",
      );
    }
  };

  const descargarLE = async (idContenedor) => {
    // [EXPERT_ANALYSIS]: NUEVO REQUERIMIENTO (REVERSIÓN) - QUÉ: Ahora ambos botones descargan la "Lista de Empaque" original.
    // POR QUÉ: A petición del usuario para unificar todas las descargas hacia el documento de LE.
    // IMPACTO: El usuario obtiene la Lista de Empaque (LE_contenedor_) al presionar cualquier botón de descarga.
    
    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/contenedores/descargar-le/${idContenedor}`,
        {
          method: "GET",
        },
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `LE_contenedor_${idContenedor}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error al descargar LE:", err);
      toastCenter.current?.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo descargar el archivo",
      });
    }

    /* // --- CÓDIGO DE REDIRECCIÓN A RESUMEN (COMENTADO POR REQUERIMIENTO) ---
    const url_cc = `${API_URL}/api/contenedores/descargar-cc/${idContenedor}`;
    window.open(url_cc, "_blank");
    // --- FIN CÓDIGO REDIRECCIÓN --- */
  };

  const actionTemplate = (rowData) => (
    <div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
      <Button
        id={`btn-contenedores-asociar-${rowData.IdContenedor}`}
        icon="pi pi-pen-to-square"
        className="p-button-rounded p-button-info"
        onClick={() => {
          //console.log("🔹 contenedor seleccionado:", rowData);
          setSelectedContenedor(rowData);
          setAsociarModalOpen(true);
        }}
        tooltip={translations.AsociarPedidoContenedor}
        tooltipOptions={{ position: "top" }}
        disabled={rowData.sNombreEstadoContenedor === "DESPACHADO"}
      />

      <Button
        id={`btn-contenedores-descargar-le-${rowData.IdContenedor}`}
        icon="pi pi-download"
        className="p-button-rounded p-button-info"
        onClick={() => descargarLE(rowData.IdContenedor)}
        tooltip="Descargar LE"
        tooltipOptions={{ position: "top" }}
      />
    </div>
  );

  const [isAsociarModalOpen, setAsociarModalOpen] = useState(false);

  const handleUpdateContenedor = (updatedContenedor) => {
    fetchWithAuth(
      `${API_URL}/api/contenedores/${updatedContenedor.IdContenedor}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedContenedor),
      },
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            showMessage(
              "error",
              translations.title_error,
              translations.erroralactualizar,
            );
            throw new Error(translations.erroralactualizar);
          });
        }
        return response.json();
      })
      .then((data) => {
        // 🔹 Actualiza la lista de contenedores sin recargar toda la página
        setListaContenedores((prevContenedores) =>
          prevContenedores.map((contenedor) =>
            contenedor.IdContenedor === updatedContenedor.IdContenedor
              ? updatedContenedor
              : contenedor,
          ),
        );
        setEditModalContenedoresOpen(false); // 🔹 Cierra el modal
        setSelectedContenedor(null); // 🔹 Deseleccionar el contenedor para inhabilitar botones
        cargarContenedores(); // 🔹 Recarga la lista de contenedores
        showMessage(
          "success",
          translations.text_Confirmacion,
          translations.actualizacion_exitosa,
        );
      })
      .catch((err) => {
        showMessage("error", translations.erroralactualizar, err.message);
      });
  };

  const cargarContenedores = () => {
    fetchWithAuth(`${API_URL}/api/listacontenedores`)
      .then((response) => response.json())
      .then((data) => {
        // Asegurarse de que 'data' sea un array antes de intentar filtrarlo
        const safeData = Array.isArray(data) ? data : [];
        const filteredData = safeData.filter(
          (contenedor) => contenedor.sNombreEstadoContenedor !== "FINALIZADO",
        );
        setListaContenedores(filteredData);
        setFilteredListaContenedores(filteredData);
      })
      .catch((err) => {
        console.error("Error al cargar los contenedores:", err);
      });
  };

  const crearContenedor = async () => {
    try {
      // Realizar la solicitud al servidor
      const response = await fetchWithAuth(
        `${API_URL}/api/postcrearcontenedor`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Validar si la respuesta HTTP fue exitosa (status 200-299)
      if (!response.ok) {
        const errorMessage = `Error en la solicitud: ${response.status}`;
        console.error(errorMessage);
        throw new Error(errorMessage); // Lanza un error para el catch
      }

      // Convertir la respuesta a JSON
      const data = await response.json();

      // Verificar si la respuesta del servidor indica éxito
      if (data.success) {
        cargarContenedores(); // Recarga la lista después de la creación
      } else {
        console.error("Error al crear contenedor:", data.message);
        alert(`Error: ${data.message}`); // Muestra un mensaje al usuario
      }
    } catch (err) {
      // Manejo de errores en el cliente (ejemplo: error de red o servidor caído)
      console.error("Error al crear contenedor:", err.message);
      alert(
        "Hubo un problema al crear el contenedor. Por favor, inténtalo de nuevo más tarde.",
      );
    } finally {
      // Ocultar el indicador de carga, si usaste uno
      console.log("Finalizó la operación de crear contenedor.");
    }
  };

  return (
    <>
      <Toast ref={toastCenter} position="top-center" baseZIndex={9999} />
      <ConfirmDialog />
      <div className="contenedorprincipal pagina-contenedores">
        <h1 className="titulo">{translations.GestionContenedores}</h1>
        <div className="botonessuperiores">
          <Button
            id="btn-contenedores-crear"
            label={translations.CrearContenedor}
            icon="pi pi-plus"
            className="p-button-success"
            onClick={crearContenedor}
          />

          <Button
            id="btn-contenedores-editar"
            label={translations.BotonEditarContenedor}
            icon="pi pi-pencil"
            className="p-button-warning"
            onClick={() => {
              handleEditContenedor();
            }}
            disabled={!selectedContenedor}
          />

          {/* <Button
            label={translations.BotonEliminarContenedor}
            icon="pi pi-delete-left"
            className="p-button-danger"
            disabled={!selectedContenedor}
            onClick={() => {
              if (!["CREADO"].includes(selectedContenedor.sNombreEstadoContenedor)) {
                showMessage("error", translations.estadoincorrecto, translations.estado_eliminar_contenedor);
                return;
              }

              setSelectedContenedor(selectedContenedor);

              confirmDialog({
                message: translations.mje_eliminar_contenedor,
                header: translations.text_Confirmacion,
                icon: "pi pi-question-circle",
                acceptClassName: "p-button-primary",
                rejectClassName: "p-button-outlined",
                acceptLabel: translations.yesbutton,
                rejectLabel: translations.nobutton,
                accept: () => EliminarContenedor(selectedContenedor.IdContenedor),
                reject: () => showMessage("info", translations.accioncancelada, translations.accioncancelada),
              });
            }}
          /> */}
          <Button
            id="btn-contenedores-despachar"
            label="Despachar"
            icon="pi pi-truck"
            className="p-button-secondary"
            onClick={handleCallDespachar}
            disabled={
              !selectedContenedor ||
              selectedContenedor.sNombreEstadoContenedor === "DESPACHADO" ||
              selectedContenedor.sNombreEstadoContenedor === "CREADO"
            }
            /* tooltip="Despacha el contenedor seleccionado" */
            tooltipOptions={{ position: "top" }}
          />
          <Button
            id="btn-contenedores-finalizar"
            label="Finalizar"
            icon="pi pi-check-square"
            className="p-button-danger"
            onClick={handleCallFinalizar}
            disabled={
              !selectedContenedor ||
              selectedContenedor.sNombreEstadoContenedor !== "DESPACHADO"
            }
            /* tooltip="Finalizar el contenedor seleccionado" */
            tooltipOptions={{ position: "top" }}
          />
        </div>

        {isAsociarModalOpen && selectedContenedor && (
          <>
            {/* console.log("✅ selectedContenedor antes de pasar al modal:", selectedContenedor) */}
            <AsociarPedContenedorModal
              language={language}
              isOpen={isAsociarModalOpen}
              contenedor={selectedContenedor} // ✅ PASAMOS EL CONTENEDOR
              onClose={() => setAsociarModalOpen(false)}
              onUpdateContenedores={cargarContenedores}
            />
          </>
        )}

        {isEditModalContenedoresOpen && selectedContenedor && (
          <EditarContenedorModal
            isOpen={isEditModalContenedoresOpen}
            contenedor={selectedContenedor}
            language={language}
            onSave={(updatedContenedor) => {
              handleUpdateContenedor(updatedContenedor); // 🔹 Ahora sí lo llamas
              setEditModalContenedoresOpen(false);
              cargarContenedores();
            }}
            onClose={() => setEditModalContenedoresOpen(false)}
          />
        )}

        <div
          className="contenedor-lista-contenedores"
          style={{ width: "95%", margin: "0 auto" }}
        >
          <div style={{ marginBottom: "2px", textAlign: "center" }}>
            <input
              id="filtro-contenedores-search"
              type="text"
              placeholder={translations.searchPlaceholder}
              value={searchText}
              onChange={handleSearch}
              style={{ padding: "5px", width: "200px" }}
            />
          </div>

          <DataTable
            value={filteredListaContenedores}
            paginator
            rows={11}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} contenedores"
            responsiveLayout="scroll"
            selectionMode="single"
            sortMode="multiple"
            sortField="IdContenedor"
            sortOrder={-1} // -1 = Descendente (más recientes primero)
            stripedRows
            showGridlines
            removableSort
            className="tabla-lista-contenedores"
            selection={selectedContenedor}
            //onSelectionChange={(e) => setSelectedContenedor(e.value)}
            onSelectionChange={(e) => {
              setSelectedContenedor(e.value);
            }}
          >
            {columnsContenedores.map((col, index) => (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                body={(rowData) => {
                  let content = rowData[col.field];
                  // Si la columna es una fecha, usa Formatofecha
                  if (["dFechaDespacho"].includes(col.field)) {
                    content = Formatofecha(rowData[col.field]);
                  }
                  return (
                    <span
                      id={`contenedor-celda-${rowData.IdContenedor}-${col.field}`}
                    >
                      {content}
                    </span>
                  );
                }}
                sortable
              />
            ))}

            <Column
              header={translations.Acciones}
              body={actionTemplate}
              style={{ textAlign: "center", width: "10%" }}
              headerStyle={{ textAlign: "center" }}
            />
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default ListaContenedores;
